class MenuDrawerEl extends HTMLElement {
    constructor(){
      super();
      this.btnToggle = this.querySelector('.js-drawer-menu');
      this.svgHamb   = this.querySelector('.drawer-hamburger');
      this.svgX      = this.querySelector('.drawer-x');

      this.root    = this.querySelector('[data-md-root]');
      this.overlay = this.root?.querySelector('[data-md-overlay]');
      this.panelsC = this.root?.querySelector('[data-md-panels]');

      // Stack čuva same elemente panela, ne indekse
      this.stack = [];
      this.isOpen = false;

      this._initPanels();
      this._bind();
      this._updateIcons();
    }

    _initPanels(){
      const panels = this._panels();
      // Prvi panel vidljiv, ostali hidden
      panels.forEach((p, i)=>{
        p.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
        p.style.zIndex = i === 0 ? '2' : '1';
      });
      this.stack = [panels[0]];
    }

    _panels(){
      return [...this.root.querySelectorAll('.md__panel')];
    }
    _current(){
      return this.stack[this.stack.length - 1];
    }
    _panelById(id){
      return this.root.querySelector(`.md__panel[data-id="${id}"]`);
    }

    _bind(){
      this.btnToggle?.addEventListener('click', (e)=>{
        e.preventDefault();
        this.isOpen ? this.close() : this.open();
      });
      this.overlay?.addEventListener('click', ()=> this.close());
      document.addEventListener('keydown', (e)=>{
        if(this.isOpen && e.key === 'Escape') this.close();
      });

      // Delegacija: push/pop
      this.root?.addEventListener('click', (e)=>{
        const push = e.target.closest('[data-md-push]');
        if(push){
          e.preventDefault();
          const id = push.getAttribute('data-target');
          this.push(id);
          return;
        }
        const pop = e.target.closest('[data-md-pop]');
        if(pop){
          e.preventDefault();
          this.pop();
        }
      });
    }

    open(){
      if(this.isOpen) return;
      this.isOpen = true;
      this.root.classList.add('is-open');
      this.root.setAttribute('aria-hidden', 'false');
      this._updateIcons();
      this.btnToggle?.setAttribute('aria-expanded', 'true');

      document.body.style.overflow = 'hidden';
    }

    close(){
      if(!this.isOpen) return;
      this.isOpen = false;
      this.root.classList.remove('is-open');
      this.root.setAttribute('aria-hidden', 'true');
      this._updateIcons();
      this.btnToggle?.setAttribute('aria-expanded', 'false');

      document.body.style.overflow = '';


      // Reset na prvi panel
      const panels = this._panels();
      panels.forEach((p,i)=>{
        p.style.transition = 'none';
        p.style.transform = i === 0 ? 'translateX(0%)' : 'translateX(100%)';
        p.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
        p.style.zIndex = i === 0 ? '2' : '1';
        // force reflow
        p.offsetHeight;
        p.style.transition = '';
      });
      this.stack = [panels[0]];
      this.btnToggle?.focus();
    }

    _updateIcons(){
      if(!this.svgHamb || !this.svgX) return;
      if(this.isOpen){
        this.svgHamb.style.display = 'none';
        this.svgX.style.display = 'flex';

      } else {
        this.svgHamb.style.display = 'flex';
        this.svgX.style.display = 'none';
      }
    }

    push(targetId){
      const next = this._panelById(targetId);
      const cur  = this._current();
      if(!next || next === cur) return;

      // pripremi next: sa desne strane
      next.style.transition = 'none';
      next.style.transform  = 'translateX(100%)';
      next.setAttribute('aria-hidden','false');
      next.style.zIndex = '3';
      next.offsetHeight; // reflow
      next.style.transition = '';

      // animiraj oba: current levo, next na 0
      cur.style.zIndex  = '2';
      cur.style.transform = 'translateX(-100%)';
      next.style.transform = 'translateX(0%)';

      // kad završi, sakrij cur van ekrana i spusti z-index
      const onDone = ()=>{
        cur.setAttribute('aria-hidden','true');
        cur.style.zIndex = '1';
        cur.removeEventListener('transitionend', onDone);
      };
      cur.addEventListener('transitionend', onDone, { once:true });

      this.stack.push(next);
    }

    pop(){
      if(this.stack.length <= 1){ this.close(); return; }

      const cur  = this.stack.pop();         // trenutno aktivan
      const prev = this._current();          // panel koji vraćamo u fokus

      // pripremi prev da bude levo pa na 0 (ako nije već 0)
      prev.style.transition = 'none';
      prev.style.transform  = 'translateX(-100%)';
      prev.setAttribute('aria-hidden','false');
      prev.style.zIndex = '3';
      prev.offsetHeight;
      prev.style.transition = '';

      // animiraj: cur desno, prev u 0
      cur.style.zIndex  = '2';
      cur.style.transform = 'translateX(100%)';
      prev.style.transform = 'translateX(0%)';

      const onDone = ()=>{
        cur.setAttribute('aria-hidden','true');
        cur.style.zIndex = '1';
        cur.removeEventListener('transitionend', onDone);
      };
      cur.addEventListener('transitionend', onDone, { once:true });
    }
  }

customElements.define('menu-drawer', MenuDrawerEl);


document.addEventListener("DOMContentLoaded", ()=> {
const btn = document.querySelector('.js-account-dropdown');
const dropdown = document.querySelector('.account-block');

btn.addEventListener('click', (event) => {
  event.preventDefault();
  dropdown.classList.toggle('is-active');
});

document.addEventListener('click', (e) => {
  if (!dropdown.contains(e.target) && !btn.contains(e.target)) {        
    dropdown.classList.remove('is-active');
  }
})
})



document.querySelectorAll('.menu-dropdown-link').forEach(link => {
  const closeBtn = link.querySelector('.menu-dropdown__close');

  if (closeBtn) {
    closeBtn.addEventListener('click', e => {
      e.stopPropagation(); // prevent hover-trigger if inside
      link.classList.remove('hovered-element');
    });
  }

  link.addEventListener('mouseenter', () => link.classList.add('hovered-element'));
  link.addEventListener('mouseleave', () => link.classList.remove('hovered-element'));
});
document.querySelectorAll('.menu-dropdown-link').forEach(link => {
  const closeBtn = link.querySelector('.menu-dropdown__close');

  if (closeBtn) {
    closeBtn.addEventListener('click', e => {
      e.stopPropagation(); // prevent hover-trigger if inside
      link.classList.remove('hovered-element');
    });
  }

  link.addEventListener('mouseenter', () => link.classList.add('hovered-element'));
  link.addEventListener('mouseleave', () => link.classList.remove('hovered-element'));
});
function updateDropdownTop() {
  const header = document.querySelector('.header-fixed');
  if (!header) return;

  const headerHeight = header.getBoundingClientRect().bottom;

  document.querySelectorAll('.menu-dropdown_content-wrapper').forEach(wrapper => {
    wrapper.style.top = headerHeight + 'px';
  });

  const overlay = document.querySelector('.menu-blur-overlay');
  if (overlay) overlay.style.top = headerHeight + 'px';
}

function handleHeaderScroll() {
  const header = document.querySelector('.header-fixed');
  if (!header) return;

  if (window.scrollY > 10) {
    header.classList.add('is-scrolled');
  } else {
    header.classList.remove('is-scrolled');
  }

  updateDropdownTop();
}

// ResizeObserver prati promenu visine headera u realnom vremenu
const header = document.querySelector('.header-fixed');
if (header) {
  const ro = new ResizeObserver(() => {
    updateDropdownTop();
  });
  ro.observe(header);
}

window.addEventListener('scroll', handleHeaderScroll);
window.addEventListener('load', () => {
  handleHeaderScroll();
  updateDropdownTop();
});